import { EmptyStatus, EmptyStatusProps, useTranslationContext } from 'platform/components';
import { useIsFilterActive } from '../../store/selectors/useIsFilterActive';
import { useEagGridStore } from '../../store/useEagGridStore';
type DefaultEmptyStateRendererProps = {
  emptyStatus?: Omit<EmptyStatusProps, 'variant'>;
};
export function DefaultEmptyStateRenderer(props: DefaultEmptyStateRendererProps) {
  const t = useTranslationContext();
  const isFilterActive = useIsFilterActive();
  const store = useEagGridStore();
  const handleResetFilters = () => {
    store.deselectAll();
    store.resetFilterValues();
  };
  return isFilterActive ? <EmptyStatus variant="table" headline={t('page.datagrid.labels.emptyDueFilter')} action={{
    title: t('page.datagrid.labels.clearAllFilters'),
    onClick: handleResetFilters
  }} /> : <EmptyStatus variant="table" headline={t('page.datagrid.labels.emptyData')} {...props.emptyStatus} />;
}